import { useLoginStatus } from "@website/hooks/auth-manager";
import { MaterialIcon } from "@website/icons/material";
import { LoginStatus } from "@website/store/store";
import { Button } from "@website/ui/button";
import { Skeleton } from "@website/ui/skeleton";
import { useClientLoaded } from "@website/utils/client-loaded/useClientLoaded";
import { ProfileMenu } from "@website/widget/header/components";
import { useLoginModal } from "@website/widget/login";
import { useCallback } from "react";
import { useSnappPro } from "../hooks/use-snapp-pro";
import styles from "./header-login.module.scss";

export function HeaderLogin() {
  const { onLoginModalOpen } = useLoginModal();
  const { hasSnappPro, snappProIcon } = useSnappPro();
  const { loginStatus } = useLoginStatus();
  const { clientLoaded } = useClientLoaded();

  const handleProfileButtonClick = useCallback((event: React.MouseEvent) => {
    event.preventDefault();
    document.dispatchEvent(new CustomEvent("openProfileMenu"));
  }, []);

  if (!clientLoaded || loginStatus === LoginStatus.Pending) {
    return (
      <>
        <div className="lg:hidden">
          <Skeleton height={36} width={36} shape="circle" />
        </div>
        <div className="hidden lg:flex">
          <Skeleton height={40} width={111} className="rounded-full" />
        </div>
      </>
    );
  }

  if (loginStatus === LoginStatus.Success) {
    return (
      <div className="relative">
        {/* mobile */}
        <Button
          EndIcon={<MaterialIcon name="person" />}
          aria-label="حساب کاربری"
          className={styles["account-button-small"]}
          color="secondary"
          equalDimension
          href="/profile"
          role="link"
          size="small"
          variant="text"
        />

        {/* desktop */}
        <Button
          EndIcon={<MaterialIcon name="keyboard_arrow_down" />}
          StartIcon={<MaterialIcon name="person" />}
          className={styles["account-button"]}
          color="secondary"
          onClick={handleProfileButtonClick}
          role="button"
          size="medium"
          variant="round-outline"
        >
          حساب کاربری
        </Button>
        {Boolean(hasSnappPro) && (
          <img
            className="absolute -bottom-3 right-1 lg:right-2"
            src={snappProIcon}
            alt="snapp-pro-icon"
          />
        )}
        <ProfileMenu isHomePage={false} />
      </div>
    );
  }

  return (
    <>
      {/*mobile*/}
      <Button
        EndIcon={<MaterialIcon name="person" />}
        aria-label={`${"ورود"} | ${"ثبت نام"}`}
        className={styles["login-button-small"]}
        color="secondary"
        equalDimension
        // href={`${web}/login`}
        // role="link"
        onClick={onLoginModalOpen}
        role="button"
        size="small"
        target="_blank"
        variant="round"
      />

      {/*desktop*/}
      <Button
        aria-label={`${"ورود"} ${"و"} ${"ثبت نام"}`}
        className={styles["login-button"]}
        color="secondary"
        // href={`${web}/login`}
        // role="link"
        onClick={onLoginModalOpen}
        size="medium"
        target="_blank"
        variant="round"
      >
        ورود | ثبت نام
      </Button>
    </>
  );
}
